




















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon
  }
})
export default class BaseHeader extends Vue {
}
